/** zh-CN catalogue `session` (W3-09; English: src/app/session.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'session',
  locale: 'zh-CN',
  messages: {
    songLoadFailed: '无法加载曲目：{reason}。谱面已在没有音乐的情况下打开。',
    hitsoundsFailed: '无法加载 {count, plural, other {# 个自定义打击音}}。这些音符改为播放皮肤的音效。',
    recovered: '已从上次会话恢复 {count, plural, other {# 次编辑}}。',
    replayErrorTitle: '部分最近的更改无法恢复',
    replayErrorBody:
      '谱面已在最后一个正常状态打开。重放已保存的更改时停止，原因：{error}。请下载恢复数据以保留其余内容（用于提交错误报告或手动恢复）。',
    replayErrorDownload: '下载恢复数据',
    replayErrorContinue: '继续编辑',
    recoveryFailed: '无法读取恢复数据：{error}',
    historyNotRestored: '无法恢复撤销历史。更早的状态仍保存在“版本”中。',
    lockLostTitle: '此谱面现在正在另一个标签页中编辑',
    lockLostBody:
      '另一个标签页接管了“{name}”，此标签页无法再保存它。接管后在此处所做的更改未被保存。请重新加载以使用最新版本继续。',
    lockLostReload: '重新加载',
    lockedTitle: '“{name}”已在另一个标签页中打开',
    lockedBody: '同一时间只能在一个标签页中编辑谱面，这样两个标签页的更改永远不会混在一起。',
    lockedSwitch: '切换到该标签页',
    lockedSwitchHelp: '在另一个标签页中继续编辑。此标签页返回谱面库。',
    lockedHere: '改为在此处编辑',
    lockedHereHelp: '另一个标签页会保存并关闭谱面，然后返回它的谱面库。',
    lockedSwitched:
      'Phiedit 已请求另一个标签页切换到前台。如果浏览器没有切换，请在标签栏中选择显示“{name}”的 Phiedit 标签页。',
    lockedSwitchManual: '请在标签栏中选择显示“{name}”的 Phiedit 标签页，在那里继续编辑。',
    lockedKept: '另一个标签页保留了“{name}”。请切换到该标签页进行编辑。',
    takeOverFailed: '无法将谱面移到此标签页：{reason}',
    handedOff: '“{name}”现已在另一个标签页中打开。移动前所有内容均已保存。',
    closeFailed: '谱面未能正常关闭（{reason}）。其更改已保留，下次打开时会恢复。',
    skinFailed: '无法加载皮肤（{reason}），已改用内置皮肤。',
    unavailable: '此浏览器无法使用{feature}：{reason}',
    unknownReason: '未知错误',
    reasonNoWebAudio: '浏览器不支持 Web Audio 或此处不允许使用，因此预览将没有声音',
    reasonWorkerNotStarted: '无法启动其后台工作线程',
    reasonWorkerStopped: '它已被关闭',
    featureAudio: '音频播放',
    featureIo: '导入和导出',
    featureAnalysis: '谱面检查',
    featureDsp: '音频分析（波形、速度检测）',
    featureSkins: '皮肤',
    featureProblems: '问题列表',
    featureTextures: '谱面图片',
    songMissing: '此浏览器的存储中缺少曲目文件“{file}”，因此谱面已在没有音乐的情况下打开。',
    songNotInPackage: '“{file}”不在谱面包中，因此谱面已在没有音乐的情况下打开。',
    addSong: '添加曲目',
    openFailedReason:
      '{code, select, lockedElsewhere {此谱面已在另一个标签页中打开。同一时间只能在一个标签页中编辑谱面：请切换到那个标签页，或从此处的谱面库打开谱面以将其移过来。} lockLost {另一个标签页接管了此谱面。} notFound {此浏览器的存储中已没有此谱面。它可能已在另一个标签页中被删除。} quota {浏览器的存储空间已满，因此无法加载谱面。请释放一些空间（设置 > 存储）后重试。} io {无法读取浏览器的存储。请重试；如果一直失败，请重新加载页面。} other {加载时出现了问题：{error}}}',
  },
};

export default catalog;
